import React from 'react';
import './courseDetailsValidityCrd.css'

function C2wCourseDetailsValidityCrd({ obj = null, svg = null }) {
  return (
    <div className='C2wCourseDetailsValidityCrd_ctn'>
      {svg}
      <div className='title_hold'>
        {obj?.title}:
        <div className='C2wWrapSapn' style={{ color: '#fff', fontWeight: '500' }}>
          {obj?.value}
        </div>
      </div>
    </div>
  )
}

export default C2wCourseDetailsValidityCrd
